<audio #audioPlayer></audio>

<div class="container mt-5">

  <!-- Loading Overlay -->
  <div *ngIf="isLoadingAction"
    class="position-fixed top-0 start-0 w-100 h-100 bg-dark opacity-50 d-flex justify-content-center align-items-center"
    style="z-index: 1050;">
    <div class="spinner-border text-light" role="status">
      <span class="visually-hidden">Loading...</span>
    </div>
  </div>


  <div class="row justify-content-center">
    <div class="col-lg-10 col-md-12" [class.pointer-events-none]="isLoadingAction" [class.opacity-50]="isLoadingAction">
      <div class="card shadow">
        <div class="card-header bg-primary text-white text-center py-3">
          <h3 class="mb-0">{{ isEditMode ? 'Edit Organization' : 'Create Organization' }}</h3>
        </div>
        <div class="card-body p-4">
          <form #orgForm="ngForm" (ngSubmit)="onSubmit()">
            <!-- Basic Organization Information -->
            <div class="card mb-4">
              <div class="card-header bg-light">
                <h5 class="mb-0">Basic Information</h5>
              </div>
              <div class="card-body">
                <div class="row">
                  <div class="col-md-6 mb-3">
                    <label for="name" class="form-label fw-semibold">Organization Name</label>
                    <input type="text" class="form-control" id="name" name="name" [(ngModel)]="organization.name"
                      required [readOnly]="isEditMode" [class.bg-light]="isEditMode">
                    <div *ngIf="orgForm.submitted && orgForm.controls['name']?.errors?.['required']"
                      class="text-danger small mt-1">
                      Organization name is required
                    </div>
                  </div>
                  <div class="col-md-6 mb-3">
                    <label for="orgType" class="form-label fw-semibold">Organization Type</label>
                    <select id="orgType" [(ngModel)]="organization.organizationTypeId" name="orgType"
                      class="form-select form-select-sm">
                      <option [ngValue]="null" selected>--Select Organization type--</option>
                      <option *ngFor="let orgType of organizationTypes" [value]="orgType.id"> {{ orgType.name }}
                      </option>
                    </select>
                  </div>
                </div>

                <div class="row">
                  <div class="col-md-6 mb-3">
                    <label for="name" class="form-label fw-semibold">AAD Admin Group Id</label>
                    <input type="text" class="form-control" id="adminGroupId" name="adminGroupId" [(ngModel)]="organization.adminGroupId"
                      [class.bg-light]="isEditMode">
                  </div>
                </div>

                <!-- <div class="row">
                  <div class="col-md-6 mb-3">
                    <div class="form-check">
                      <input class="form-check-input" type="checkbox" id="isDepartmentEntryComplete"
                        name="isDepartmentEntryComplete" [(ngModel)]="organization.isDepartmentEntryComplete">
                      <label class="form-check-label" for="isDepartmentEntryComplete">
                        Department Entry Complete
                      </label>
                    </div>
                  </div>
                  <div class="col-md-6 mb-3" *ngIf="organization.isDepartmentEntryComplete">
                    <label for="completionDate" class="form-label fw-semibold">Completion Date</label>
                    <input type="date" class="form-control" id="completionDate" name="completionDate"
                      [(ngModel)]="organization.departmentEntryCompletionDate">
                  </div>
                </div> -->
              </div>
            </div>

            <!-- Smart App Environments -->
            <div class="card mb-4">
              <div class="card-header bg-light d-flex justify-content-between align-items-center">
                <h5 class="mb-0">Smart App Environments</h5>
                <button type="button" class="btn btn-primary btn-sm" (click)="openEnvironmentModal()">
                  <i class="bi bi-plus-circle me-1"></i> Add Environment
                </button>
              </div>
              <div class="card-body">
                <div *ngIf="organization.smartAppEnvironments?.length === 0" class="text-muted mb-2">
                  No environments configured yet.
                </div>
                <table *ngIf="organization.smartAppEnvironments?.length > 0" class="table table-striped table-hover table-sm">
                  <thead>
                    <tr>
                      <th scope="col">Name</th>
                      <th scope="col">Default</th>
                      <th scope="col">Actions</th>
                      <th scope="col" class="text-center">Apply Data</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr *ngFor="let env of organization.smartAppEnvironments">
                      <td>{{ env.name }}</td>
                      <td>
                        <span class="badge" [ngClass]="env.isDefault ? 'bg-success' : 'bg-secondary'">
                          {{ env.isDefault ? 'Default' : 'Not Default' }}
                        </span>
                      </td>
                      <td>
                        <button type="button" class="btn btn-outline-primary btn-sm me-2"
                          (click)="openEnvironmentModal(env)">
                          <i class="bi bi-pencil"></i> Edit
                        </button>
                        <button type="button" class="btn btn-outline-danger btn-sm"
                          (click)="deleteEnvironment(env.id)" [disabled]="env.isDefault">
                          <i class="bi bi-trash"></i> Delete
                        </button>
                      </td>
                      <td>
                        <div class="dropdown">
                          <button class="btn btn-outline-primary dropdown-toggle mb-2 w-100" type="button"
                            data-bs-toggle="dropdown" aria-expanded="false">
                            <i class="bi bi-file-earmark-arrow-down"></i> Data Type
                          </button>
                          <ul class="dropdown-menu">
                            <li><a class="dropdown-item" role="button" (click)="applyData('Department', env.id)">Departments</a>
                            </li>
                            <li><a class="dropdown-item" role="button" (click)="applyData('KbItem', env.id)">Knowledge Base Items</a>
                            </li>
                          </ul>
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>

            <!-- Automation Configuration -->
            <div class="card mb-4">
              <div class="card-header bg-light">
                <h5 class="mb-0">Automation Configuration</h5>
              </div>
              <div class="card-body">
                <div class="row mb-3 mt-3">
                  <div class="col">
                    <div class="form-check form-switch">
                      <input class="form-check-input" role="switch" type="checkbox"
                        [(ngModel)]="organization.autoUpdateEscalationMap" id="autoUpdateEscalationMap"
                        name="autoUpdateEscalationMap">
                      <label for="autoUpdateEscalationMap" class="form-check-label">Auto Update Escalation Map</label>
                    </div>
                  </div>
                  <div class="col">
                    <div class="form-check form-switch">
                      <input class="form-check-input" role="switch" type="checkbox"
                        [(ngModel)]="organization.autoUpdateIntentMap" id="autoUpdateIntentMap"
                        name="autoUpdateIntentMap">
                      <label for="autoUpdateIntentMap" class="form-check-label">Auto Update Intent Map</label>
                    </div>
                  </div>
                  <div class="col">
                    <div class="form-check form-switch">
                      <input class="form-check-input" role="switch" type="checkbox"
                        [(ngModel)]="organization.autoUpdateAQA" id="autoUpdateAQA" name="autoUpdateAQA">
                      <label for="autoUpdateAQA" class="form-check-label">Auto Update AQA</label>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- Action Buttons -->
            <div class="d-flex justify-content-center mt-4">
              <button type="submit" class="btn btn-primary me-2" [disabled]="orgForm.invalid">
                {{ isEditMode ? 'Save Changes' : 'Create Organization' }}
              </button>
              <button type="button" class="btn btn-secondary" (click)="cancel()">
                Cancel
              </button>
            </div>

            <!-- Import Knowledge Base Control Accordion -->
            <div class="accordion mt-5" id="orchestrationAccordion">
              <div class="accordion-item border-0 shadow">
                <h2 class="accordion-header" id="orchestrationHeader">
                  <button class="accordion-button collapsed bg-primary text-white py-3" type="button"
                    data-bs-toggle="collapse" data-bs-target="#orchestrationCollapse" aria-expanded="false"
                    aria-controls="orchestrationCollapse">
                    <h4 class="mb-0">Import Knowledge Base</h4>
                  </button>
                </h2>
                <div id="orchestrationCollapse" class="accordion-collapse collapse"
                  aria-labelledby="orchestrationHeader" data-bs-parent="#orchestrationAccordion">
                  <div class="accordion-body p-4">
                    <button type="button" class="btn btn-success mb-3" (click)="startDataSeed()"
                      [disabled]="isProcessing || isLoadingAction">
                      <i class="bi bi-play-circle me-2"></i> Start Data Seed
                      <span *ngIf="isLoadingAction" class="spinner-border spinner-border-sm ms-2" role="status"></span>
                    </button>
                    <button type="button" class="btn btn-success mb-3 ms-2" (click)="provisionSmallTalk()"
                      [disabled]="isProcessing || isLoadingAction || !organization.id">
                      <i class="bi bi-chat-dots me-2"></i> Provision SmallTalk Items
                      <span *ngIf="isLoadingAction" class="spinner-border spinner-border-sm ms-2" role="status"></span>
                    </button>
                    <div id="orchestrationTable" class="collapse show">
                      <table class="table table-striped table-hover table-responsive table-sm">
                        <thead>
                          <tr>
                            <th scope="col">Runtime Status</th>
                            <th scope="col">Progress</th>
                            <th scope="col">Details</th>
                            <th scope="col">Created</th>
                            <th scope="col">Last Updated</th>
                            <th scope="col" class="text-center">Actions</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr *ngFor="let instance of instances">
                            <td>
                              <span class="badge" [ngClass]="{
                                'bg-info': instance.RuntimeStatus === 'Running' || instance.RuntimeStatus === 'Pending',
                                'bg-success': instance.RuntimeStatus === 'Completed',
                                'bg-danger': instance.RuntimeStatus === 'Failed' || instance.RuntimeStatus === 'Terminated',
                                'bg-warning': instance.RuntimeStatus === 'Suspended'
                              }">{{ instance.RuntimeStatus }}</span>
                            </td>
                            <td>
                              <span *ngIf="instance.TotalRecords > 0; else noProgress">
                                {{ instance.ProcessedCount }} / {{ instance.TotalRecords }} ({{ instance.PendingCount }}
                                pending)
                              </span>
                              <ng-template #noProgress>N/A</ng-template>
                            </td>
                            <td>{{ instance.Details || 'N/A' }}</td>
                            <td>{{ instance.CreatedAt | date:'short' }}</td>
                            <td>{{ instance.LastUpdatedAt | date:'short' }}</td>
                            <td>
                              <div class="btn-group" role="group">
                                <button type="button" class="btn btn-outline-warning btn-sm" (click)="refresh()"
                                  [disabled]="isLoadingAction" ngbTooltip="Refresh">
                                  <i class="bi bi-arrow-repeat"></i>
                                  <span *ngIf="isLoadingAction" class="spinner-border spinner-border-sm ms-1"
                                    role="status"></span>
                                </button>
                                <button type="button" class="btn btn-outline-dark btn-sm"
                                  (click)="controlInstance(instance.InstanceId, 'suspend')"
                                  [disabled]="instance.RuntimeStatus !== 'Running' || isLoadingAction"
                                  ngbTooltip="Suspend">
                                  <i class="bi bi-pause"></i>
                                  <span *ngIf="isLoadingAction" class="spinner-border spinner-border-sm ms-1"
                                    role="status"></span>
                                </button>
                                <button type="button" class="btn btn-outline-success btn-sm"
                                  (click)="controlInstance(instance.InstanceId, 'resume')"
                                  [disabled]="instance.RuntimeStatus !== 'Suspended' || isLoadingAction"
                                  ngbTooltip="Resume">
                                  <i class="bi bi-play"></i>
                                  <span *ngIf="isLoadingAction" class="spinner-border spinner-border-sm ms-1"
                                    role="status"></span>
                                </button>
                                <button type="button" class="btn btn-outline-primary btn-sm"
                                  (click)="controlInstance(instance.InstanceId, 'terminate')"
                                  [disabled]="instance.RuntimeStatus === 'Completed' || instance.RuntimeStatus === 'Terminated' || isLoadingAction"
                                  ngbTooltip="Terminate">
                                  <i class="bi bi-stop"></i>
                                  <span *ngIf="isLoadingAction" class="spinner-border spinner-border-sm ms-1"
                                    role="status"></span>
                                </button>
                                <button type="button" class="btn btn-outline-danger btn-sm"
                                  (click)="purgeInstance(instance.InstanceId)" [disabled]="isLoadingAction"
                                  ngbTooltip="Purge">
                                  <i class="bi bi-trash"></i>
                                  <span *ngIf="isLoadingAction" class="spinner-border spinner-border-sm ms-1"
                                    role="status"></span>
                                </button>
                              </div>
                            </td>
                          </tr>
                          <tr *ngIf="instances.length === 0">
                            <td colspan="8" class="text-center">No import instances found.</td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>

              <!-- Import/Export Actions Accordion -->
              <div class="accordion-item border-0 shadow mt-4">
                <h2 class="accordion-header" id="importExportHeader">
                  <button class="accordion-button collapsed bg-primary text-white py-3" type="button"
                    data-bs-toggle="collapse" data-bs-target="#importExportCollapse" aria-expanded="false"
                    aria-controls="importExportCollapse">
                    <h4 class="mb-0">TSV Actions</h4>
                  </button>
                </h2>
                <div id="importExportCollapse" class="accordion-collapse collapse" aria-labelledby="importExportHeader"
                  data-bs-parent="#orchestrationAccordion">
                  <div class="accordion-body p-4">
                    <div class="row mb-4">
                      <div class="col-md-6">
                        <h6 class="fw-semibold mb-3">Export TSV</h6>
                        <button type="button" class="btn btn-outline-primary w-100" (click)="generateTsv()"
                          [disabled]="!organization.id">
                          <i class="bi bi-download me-2"></i> Download TSV
                        </button>
                      </div>
                      <div class="col-md-6">
                        <h6 class="fw-semibold mb-3">Integrate TSV into AQA</h6>
                        <div class="dropdown">
                          <button class="btn btn-outline-primary dropdown-toggle mb-2 w-100" type="button"
                            data-bs-toggle="dropdown" aria-expanded="false">
                            <i class="bi bi-file-earmark-arrow-down"></i> Project
                          </button>
                          <ul class="dropdown-menu">
                            <li><a class="dropdown-item" role="button" (click)="integrateAQA('SmallTalk')">SmallTalk</a>
                            </li>
                            <li><a class="dropdown-item" role="button" (click)="integrateAQA('Web')">Web</a>
                            </li>
                            <li><a class="dropdown-item" role="button" (click)="integrateAQA('Phone')">Phone</a>
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col mb-3">
                        <h6 class="fw-semibold mb-3">Import SmallTalk TSV</h6>
                        <div class="input-group">
                          <input type="file" class="form-control" id="smallTalkTsvFile"
                            (change)="onSmallTalkFileSelected($event)" accept=".tsv" [disabled]="!organization.id">
                          <button class="btn btn-outline-success" type="button" (click)="uploadSmallTalkTsv()"
                            [disabled]="!smallTalkFile || !organization.id">
                            <i class="bi bi-upload me-2"></i> Upload
                          </button>
                        </div>
                      </div>
                      <div class="col mb-3">
                        <h6 class="fw-semibold mb-3">Import Web TSV</h6>
                        <div class="input-group">
                          <input type="file" class="form-control" id="webTsvFile" (change)="onWebFileSelected($event)"
                            accept=".tsv" [disabled]="!organization.id">
                          <button class="btn btn-outline-success" type="button" (click)="uploadWebTsv()"
                            [disabled]="!webFile || !organization.id">
                            <i class="bi bi-upload me-2"></i> Upload
                          </button>
                        </div>
                      </div>
                      <div class="col mb-3">
                        <h6 class="fw-semibold mb-3">Import Phone TSV</h6>
                        <div class="input-group">
                          <input type="file" class="form-control" id="phoneTsvFile"
                            (change)="onPhoneFileSelected($event)" accept=".tsv" [disabled]="!organization.id">
                          <button class="btn btn-outline-success" type="button" (click)="uploadPhoneTsv()"
                            [disabled]="!phoneFile || !organization.id">
                            <i class="bi bi-upload me-2"></i> Upload
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <!-- Intent Map Accordion -->
              <div class="accordion-item border-0 shadow mt-4">
                <h2 class="accordion-header" id="intentMapHeader">
                  <button class="accordion-button collapsed bg-primary text-white py-3" type="button"
                    data-bs-toggle="collapse" data-bs-target="#intentMapCollapse" aria-expanded="false"
                    aria-controls="intentMapCollapse">
                    <h4 class="mb-0">Intent Map</h4>
                  </button>
                </h2>
                <div id="intentMapCollapse" class="accordion-collapse collapse" aria-labelledby="intentMapHeader"
                  data-bs-parent="#orchestrationAccordion">
                  <div class="accordion-body p-4">
                    <div class="row mb-4">
                      <div class="col-md-6 border-end">
                        <h6 class="fw-semibold mb-3">Generate Intent Maps</h6>
                        <button type="button" class="btn btn-outline-primary w-100" (click)="generateIntentMap()"
                          [disabled]="!organization.id">
                          <i class="bi bi-download me-2"></i> Download Maps
                        </button>
                      </div>
                      <div class="col-md-6">
                        <h6 class="fw-semibold mb-3">Integrate Intent Maps</h6>
                        <button type="button" class="btn btn-outline-primary w-100 mb-2"
                          (click)="integrateWebIntentMap()" [disabled]="!organization.id">
                          <i class="bi bi-arrow-right-circle me-2"></i> Integrate Web
                        </button>
                        <button type="button" class="btn btn-outline-primary w-100" (click)="integratePhoneIntentMap()"
                          [disabled]="!organization.id">
                          <i class="bi bi-arrow-right-circle me-2"></i> Integrate Phone
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Environment Modal -->
<ng-template #environmentModal let-modal>
  <div class="modal-header">
    <h2 id="modalTitle">{{ isEnvironmentEditMode ? 'Edit Environment' : 'Add Environment' }}</h2>
    <button type="button" class="btn-close" (click)="modal.dismiss()"></button>
  </div>
  <div class="modal-body">
    <form #envForm="ngForm" (ngSubmit)="saveEnvironment()">
      <div class="mb-3">
        <label for="envName" class="form-label fw-semibold">Environment Name</label>
        <input type="text" class="form-control" id="envName" name="envName" [(ngModel)]="currentEnvironment.name"
          required>
        <div *ngIf="envForm.submitted && envForm.controls['envName']?.errors?.['required']" class="text-danger small mt-1">
          Environment name is required
        </div>
      </div>
      <div class="mb-3">
        <div class="form-check">
          <input class="form-check-input" type="checkbox" id="isDefault" name="isDefault"
            [(ngModel)]="currentEnvironment.isDefault" [disabled]="currentEnvironment.isDefault && isEnvironmentEditMode">
          <label class="form-check-label" for="isDefault">Set as Default</label>
        </div>
      </div>
      <!-- SMART Phone Configuration -->
      <div class="card mb-3">
        <div class="card-header bg-light">
          <h5 class="mb-0">SMART Phone Configuration</h5>
        </div>
        <div class="card-body">
          <div class="row mb-3">
            <div class="col-md-12">
              <label for="smartPhoneProjectName" class="form-label fw-semibold">Project Name</label>
              <input type="text" class="form-control" id="smartPhoneProjectName" name="smartPhoneProjectName"
                [(ngModel)]="currentEnvironment.smartPhoneProjectName"
                placeholder="Enter project name for phone intents">
            </div>
          </div>
          <div class="row mb-3">
            <div class="col-md-12">
              <label for="smartPhoneConnectionString" class="form-label fw-semibold">Connection String</label>
              <input type="text" class="form-control" id="smartPhoneConnectionString"
                name="smartPhoneConnectionString" [(ngModel)]="currentEnvironment.smartPhoneConnectionString">
            </div>
          </div>
          <div class="row mb-3">
            <div class="col-md-12">
              <label for="smartPhonePersonality" class="form-label fw-semibold">Personality</label>
              <textarea class="form-control" id="smartPhonePersonality" name="smartPhonePersonality"
                [(ngModel)]="currentEnvironment.smartPhonePersonality" rows="3"
                placeholder="Enter personality instructions"></textarea>
            </div>
          </div>
          <div class="mb-3">
            <label class="form-label fw-semibold">Welcome Messages by Language</label>
            <div class="mt-2">
              <div *ngIf="smartPhoneWelcomeMessages.length === 0" class="text-muted mb-2 small">
                No welcome messages added yet.
              </div>
              <div *ngFor="let msg of smartPhoneWelcomeMessages; let i = index" class="input-group mb-2">
                <select class="form-select" [(ngModel)]="msg.language" name="smartPhoneLang{{ i }}" required>
                  <option value="" disabled>Select Language</option>
                  <option value="en">English</option>
                  <option value="cy">Welsh</option>
                  <option value="gd">Scottish Gaelic</option>
                </select>
                <textarea class="form-control" [(ngModel)]="msg.message" name="smartPhoneMsg{{ i }}" rows="2"
                  placeholder="Enter welcome message" required></textarea>
                <button type="button" class="btn btn-outline-danger"
                  (click)="removeWelcomeMessage(smartPhoneWelcomeMessages, i)">
                  <i class="bi bi-trash"></i>
                </button>
                <button type="button" class="btn btn-outline-primary" (click)="playText(msg.message)">
                  <i class="bi bi-volume-up"></i>
                </button>
              </div>
              <button type="button" class="btn btn-link text-primary p-0"
                (click)="addWelcomeMessage(smartPhoneWelcomeMessages)">
                <i class="bi bi-plus-circle me-1"></i> Add Welcome Message
              </button>
            </div>
          </div>
          <hr />
          <div class="mb-3">
            <label class="form-label fw-semibold">First Prompts by Language</label>
            <div class="mt-2">
              <div *ngIf="smartPhoneFirstPrompts.length === 0" class="text-muted mb-2 small">
                No first prompts added yet.
              </div>
              <div *ngFor="let msg of smartPhoneFirstPrompts; let i = index" class="input-group mb-2">
                <select class="form-select" [(ngModel)]="msg.language" name="smartPhoneFirstPromptLang{{ i }}" required>
                  <option value="" disabled>Select Language</option>
                  <option value="en">English</option>
                  <option value="cy">Welsh</option>
                  <option value="gd">Scottish Gaelic</option>
                </select>
                <textarea class="form-control" [(ngModel)]="msg.message" name="smartPhoneFirstPromptMsg{{ i }}" rows="2"
                  placeholder="Enter first prompt" required></textarea>
                <button type="button" class="btn btn-outline-danger"
                  (click)="removeWelcomeMessage(smartPhoneFirstPrompts, i)">
                  <i class="bi bi-trash"></i>
                </button>
                <button type="button" class="btn btn-outline-primary" (click)="playText(msg.message)">
                  <i class="bi bi-volume-up"></i>
                </button>
              </div>
              <button type="button" class="btn btn-link text-primary p-0"
                (click)="addWelcomeMessage(smartPhoneFirstPrompts)">
                <i class="bi bi-plus-circle me-1"></i> Add First Prompt
              </button>
            </div>
          </div>
        </div>
      </div>
      <!-- SMART Chat Configuration -->
      <div class="card mb-3">
        <div class="card-header bg-light">
          <h5 class="mb-0">SMART Chat Configuration</h5>
        </div>
        <div class="card-body">
          <div class="row mb-3">
            <div class="col-md-12">
              <label for="smartChatProjectName" class="form-label fw-semibold">Project Name</label>
              <input type="text" class="form-control" id="smartChatProjectName" name="smartChatProjectName"
                [(ngModel)]="currentEnvironment.smartChatProjectName" placeholder="Enter project name for intent map">
            </div>
          </div>
          <div class="row mb-3">
            <div class="col-md-12">
              <label for="smartChatConnectionString" class="form-label fw-semibold">Connection String</label>
              <input type="text" class="form-control" id="smartChatConnectionString"
                name="smartChatConnectionString" [(ngModel)]="currentEnvironment.smartChatConnectionString">
            </div>
          </div>
          <div class="row mb-3">
            <div class="col-md-12">
              <label for="smartChatPersonality" class="form-label fw-semibold">Personality</label>
              <textarea class="form-control" id="smartChatPersonality" name="smartChatPersonality"
                [(ngModel)]="currentEnvironment.smartChatPersonality" rows="3"
                placeholder="Enter personality instructions"></textarea>
            </div>
          </div>
          <div class="mb-3">
            <label class="form-label fw-semibold">Welcome Messages by Language</label>
            <div class="mt-2">
              <div *ngIf="smartChatWelcomeMessages.length === 0" class="text-muted mb-2 small">
                No welcome messages added yet.
              </div>
              <div *ngFor="let msg of smartChatWelcomeMessages; let i = index" class="input-group mb-2">
                <select class="form-select" [(ngModel)]="msg.language" name="smartChatLang{{ i }}" required>
                  <option value="" disabled>Select Language</option>
                  <option value="en">English</option>
                  <option value="cy">Welsh</option>
                  <option value="gd">Scottish Gaelic</option>
                </select>
                <textarea class="form-control" [(ngModel)]="msg.message" name="smartChatMsg{{ i }}" rows="2"
                  placeholder="Enter welcome message" required></textarea>
                <button type="button" class="btn btn-outline-danger"
                  (click)="removeWelcomeMessage(smartChatWelcomeMessages, i)">
                  <i class="bi bi-trash"></i>
                </button>
                <button type="button" class="btn btn-outline-primary" (click)="playText(msg.message)">
                  <i class="bi bi-volume-up"></i>
                </button>
              </div>
              <button type="button" class="btn btn-link text-primary p-0"
                (click)="addWelcomeMessage(smartChatWelcomeMessages)">
                <i class="bi bi-plus-circle me-1"></i> Add Welcome Message
              </button>
            </div>
          </div>
          <hr />
          <div class="row mb-3">
            <div class="col-md-12">
              <label for="smallTalkProjectName" class="form-label fw-semibold">SmallTalk Project Name</label>
              <input type="text" class="form-control" id="smallTalkProjectName" name="smallTalkProjectName"
                [(ngModel)]="currentEnvironment.smallTalkProjectName" placeholder="Enter SmallTalk Project Name">
            </div>
          </div>
        </div>
      </div>
      <!-- Language Service Configuration -->
      <div class="card mb-3">
        <div class="card-header bg-light">
          <h5 class="mb-0">Language Service Configuration</h5>
        </div>
        <div class="card-body">
          <div class="row mb-3">
            <div class="col-md-12">
              <label for="languageServiceApiKey" class="form-label fw-semibold">Language Service ApiKey</label>
              <input type="text" class="form-control" id="languageServiceApiKey" name="languageServiceApiKey"
                [(ngModel)]="currentEnvironment.languageServiceApiKey">
            </div>
          </div>
          <div class="row mb-3">
            <div class="col-md-12">
              <label for="languageServiceEndpoint" class="form-label fw-semibold">Language Service Endpoint</label>
              <input type="text" class="form-control" id="languageServiceEndpoint" name="languageServiceEndpoint"
                [(ngModel)]="currentEnvironment.languageServiceEndpoint">
            </div>
          </div>
        </div>
      </div>
      <div class="d-flex justify-content-end">
        <button type="submit" class="btn btn-primary me-2" [disabled]="envForm.invalid">Save</button>
        <button type="button" class="btn btn-secondary" (click)="modal.dismiss()">Cancel</button>
      </div>
    </form>
  </div>
</ng-template>

<ng-template #importModal let-modal>
  <div class="modal-header">
    <h2 id="modalTitle">{{ modalTitle }}</h2>
  </div>
  <div class="modal-body">
    <p>{{ modalMessage }}</p>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-secondary" (click)="modal.dismiss()">Close</button>
  </div>
</ng-template>